import { Trans } from '@lingui/react/macro'
import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { LinkIndicatorIcon } from '../common'
import { ButtonLink } from './ButtonLink'

export const ActionButton = ({
  variant = 'outlined',
  color = 'default',
  shape = 'round',
  size = 'small',
  className,
  ...props
}: ComponentProps<typeof ButtonLink>) => (
  <ButtonLink variant={variant} size={size} color={color} shape={shape} className={twMerge(className)} {...props} />
)

export const ActionColumnButton = ({
  color = 'default',
  className,
  type,
  ...props
}: Omit<ComponentProps<typeof ButtonLink>, 'type' | 'variant' | 'size' | 'shape' | 'iconPlacement'> & {
  type?: 'showEntity'
}) => {
  if (type === 'showEntity') {
    props.icon = <LinkIndicatorIcon />
    props.children = <Trans>Anzeigen</Trans>
  }
  return (
    <ButtonLink
      variant={'outlined'}
      size={'small'}
      color={color}
      shape={'round'}
      iconPlacement={'end'}
      className={twMerge(className)}
      {...props}
    />
  )
}
